import { render, staticRenderFns } from "./Add-role.vue?vue&type=template&id=5579ed07&scoped=true"
import script from "./Add-role.vue?vue&type=script&lang=js"
export * from "./Add-role.vue?vue&type=script&lang=js"
import style0 from "./Add-role.vue?vue&type=style&index=0&id=5579ed07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5579ed07",
  null
  
)

export default component.exports